import { render, staticRenderFns } from "./CmgKebabMenu.vue?vue&type=template&id=a1b9480a&scoped=true&lang=pug"
import script from "./cmg-kebab-menu.ts?vue&type=script&lang=ts&external"
export * from "./cmg-kebab-menu.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgKebabMenu.vue?vue&type=style&index=0&id=a1b9480a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b9480a",
  null
  
)

export default component.exports